import cn from 'clsx'
import { Box } from '@/components/Box/Box'
import { Card } from '@/components/Card/Card'
import { Image } from '@/components/image/image'
import { Text } from '@/components/Text/Text'

import css from './featured-icon-card.module.css'

export type FeaturedIconCardProps = {
    title: string
    description: string
    image: string
    href: string
    size?: 'base' | 'lg'
    disabled?: boolean
}

export function FeaturedIconCard({
    title,
    description,
    image,
    href,
    size = 'base',
    disabled = false,
}: FeaturedIconCardProps) {
    return (
        <Card
            className={cn(css.featureIconCard, css[size], { [css.disabled]: disabled })}
            title={`${title}\n\n${description}`}
        >
            <Box className={css.elevatedCircle}>
                <Image width={96} height={96} src={image} alt="" />
            </Box>
            <Box className={css.textContainer}>
                <FeatureIconCardTitle shouldWrap={disabled === false} href={href}>
                    {title}
                </FeatureIconCardTitle>
                <Text tag="span" size="body-sm" weight="medium" className={css.description}>
                    {description}
                </Text>
            </Box>
        </Card>
    )
}

function FeatureIconCardTitle({
    shouldWrap,
    href,
    children,
}: {
    href: string
    shouldWrap: boolean
    children: string
}) {
    const textSize = 'major-sm'

    return shouldWrap ? (
        <Text tag="a" href={href} className={css.anchor} size={textSize}>
            {children}
        </Text>
    ) : (
        <Text tag="span" size={textSize}>
            {children}
        </Text>
    )
}
